"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FONT_OPTIONS = exports.DEFAULTS = void 0;
/**
 * Hard-coded fallback at the bottom of the cascade. Also displayed in
 * the panel as the "default" value when a field is in def: true mode.
 */
exports.DEFAULTS = {
    ff: 'sans',
    fz: 16,
    fw: 400,
    fs: 100,
    os: true,
    lig: 'common',
    nv: 'normal',
    lh: 1.5,
    ls: 0,
    ws: 0,
    krn: 'auto',
    it: false,
    caps: false,
    smcp: false,
    uo: 0.15,
    dt: 0.06,
    fg: '#1a1a1a',
    bg: '#ffffff',
};
/** Built-in `FontKind` shorthands plus a few common alternatives. */
exports.FONT_OPTIONS = [
    { id: 'sans', name: 'Sans' },
    { id: 'serif', name: 'Serif' },
    { id: 'slab', name: 'Slab' },
    { id: 'mono', name: 'Mono' },
];
